module.exports = __webpack_public_path__ + "static/media/html-5.676e8188.svg";